import Sonda from "@gcloud-npm/utils.monitoring.sonda";
import getUUID from "@gcloud-npm/utils.monitoring.get-uuid";
import Request from "@/utils/fetch";
import {
  makeUpTelcoPathName,
  getAdabyronConstants,
  PROCESS_NAME,
} from "@gcloud-npm/utils.adabyron.make-up-telco-path-name";
import { calculateHeaderParams } from "@gcloud-npm/node.build-process.build-environments";
import { FAMILY_API } from "@gcloud-npm/utils.enums.environment";
import sendToRelogin from '@gcloud-npm/utils.page.send-to-relogin';

const PATH = 'catalogo/documentos';
const EVENT_NAME = 'CATALOG.GET_PRODUCT_OFFERING_ATTACHMENTS';
const METHOD = 'GET';

export const getProductOfferingAttachments = ({
  data,
  context,
  idFront = 'TC',
  build = false,
  version,
  onRedirect,
}) => {
  const { environment, userType } = context;
  const { telco: connectionData } = environment;
  const { endpoint: host } = connectionData;
  const { idPO } = data;

  const idRequest = getUUID(idFront);
  const headers2Use = calculateHeaderParams(build, FAMILY_API.TELCO, context);
  const { prefixToApply } = getAdabyronConstants(userType);

  const sonda = new Sonda({
    eventName: EVENT_NAME,
    context,
    uniqueId: idRequest,
    origin: PROCESS_NAME.CLIENT,
  });

  let queryParams = [];
  queryParams.push({ param: 'productOffering', value: idPO });
  
  let urlParamsToReplace = [];

  const URL_API = makeUpTelcoPathName({
    path: PATH,
    version,
    idRequest,
    host,
    prefixToApply,
    queryParams,
    urlParamsToReplace,
  });

  const request = new Request({
    method: METHOD,
    endpoint: URL_API,
    headers: {
      ...headers2Use,
    },
    sonda,
    onRedirect: onRedirect || sendToRelogin,
  });
  
  return request.makeRequest();
};

export default getProductOfferingAttachments;